/**
 * 2019-04-12
 * handan
 * 调查结果（显示结果）
 */

import React, { Component } from 'react'
import { Icon } from "antd";
import { NavLink, withRouter } from "react-router-dom";

class ResultShow extends Component {
  constructor(props) {
    super(props)
    this.openPage = this.openPage.bind(this);
  }
  // 身份信息核验类型渲染
  resultDetail_identity = (data) => {
    const { dataFlag } = this.props.data;
    if (dataFlag === 1) return null;
    return (
      <div className="content">
        <ul className="table">
          <li>
            <p><em>姓名</em></p>
            <span>{data.name}</span>
          </li>
          <li>
            <p><em>身份证号</em></p>
            <span>{data.idNo}</span>
          </li>
          <li>
            <p><em>性别</em></p>
            <span>{data.gender * 1 === 1 ? "男" : "女"}</span>
          </li>
          <li>
            <p><em>生日</em></p>
            <span>{data.birthday}</span>
          </li>
        </ul>
      </div>
    )
  }
  // 驾照类型渲染
  resultDetail_jiazhao = (data) => {
    const { dataFlag } = this.props.data;
    if (dataFlag === 1) return null;
    return (
      <div className="content">
        <ul className="table">
          <li>
            <p><em>驾驶证号</em></p>
            <span>{data.driversLicense}</span>
          </li>
          <li>
            <p><em>档案编号</em></p>
            <span>{data.fileNo}</span>
          </li>
          <li>
            <p><em>初领日期</em></p>
            <span>{data.licensing}</span>
          </li>
          <li>
            <p><em>准驾车型</em></p>
            <span>{data.models}</span>
          </li>
          <li>
            <p><em>累计记分</em></p>
            <span>{data.scoring}</span>
          </li>
          <li>
            <p><em>证件状态</em></p>
            <span>{data.state}</span>
          </li>
          <li>
            <p><em>有效期始</em></p>
            <span>{data.startDate}</span>
          </li>
          <li>
            <p><em>有效期至</em></p>
            <span>{data.termOfValidity}</span>
          </li>
        </ul>
      </div>
    )
  }
  // 民事诉讼类型渲染
  resultDetail = (data) => {
    const { dataFlag } = this.props.data;
    if (dataFlag === 0) return null;
    return (
      <div className="content">
        <ul className="table">
          <li>
            <p><em>标题</em></p>
            <span>{data.title}</span>
          </li>
          <li>
            <p><em>匹配度</em></p>
            <span>{data.matchRatio * 100}%</span>
          </li>
          <li>
            <p><em>内容概要</em></p>
            <span>{data.body}</span>
          </li>
          <li>
            <p><em>审核时间</em></p>
            <span>{data.sortTimeString}</span>
          </li>
        </ul>
      </div>
    )
  }
  // 金融违规类型
  resultDetailFinancial = () => {
    const { data = {} } = this.props;
    if (data.dataFlag === 0) return null;
    const { list = [] } = data.body;
    return (
      <div className="content">
        <ul className="table financial">
          <li>
            <p><em>处罚标题</em></p>
            <span>{list[0].title}</span>
          </li>
          <li>
            <p><em>处罚时间</em></p>
            <span>{list[0].time}</span>
          </li>
          <li>
            <p><em>详情链接</em></p>
            <span><a href={list[0].url} target="_blank">{list[0].url}</a></span>
          </li>
        </ul>
      </div>
    )
  }
  // 银联失信黑名单类型渲染
  resultDetail_bank = () => {
    const { data = {} } = this.props;
    if (data.dataFlag === 0) return null;
    let dataList = data.body.msg ? data.body.msg.split(",") : [];
    return (
      <div className="content">
        <ul className="table">
          {
            dataList.map((item) => {
              return (
                <li>
                  <span>{item}</span>
                </li>
              )
            })
          }
        </ul>
      </div>
    )
  }
  // 商业利益冲突
  resultDetail_shangye = () => {
    const { data = {} } = this.props;
    if (data.dataFlag === 0) return null;
    const { ryposfrs = [], rypospers = [], ryposshas = [] } = data.body;
    return (
      <div className="content">
        <ul className="table">
          {
            ryposfrs.length ? <li>人员法人信息（{ryposfrs.length}条）</li> : null 
          }
          {
            rypospers.length ? <li>人员高管信息（{rypospers.length}条）</li> : null
          }
          {
            ryposshas.length ? <li>人员股东信息（{ryposshas.length}条）</li> : null
          }
        </ul>
      </div>
    )
  }

  resultDetail_zgzs = () => {
    const { data = {} } = this.props;
    if (data.dataFlag === 1) return null;
    const { list = [] } = data.body;
    if ( list && list.length === 0) return null;
    return (
      <div className="content">
        <ul className="table">
          {
            list[0].certName ? <li>职业资格名称：{list[0].certName}</li> : null 
          }
          {
            list[0].certNo ? <li>证书编号：{list[0].certNo}</li> : null 
          }{
            list[0].chineseLevel ? <li>职业认证等级：{list[0].chineseLevel}</li> : null 
          }{
            list[0].numberLevel ? <li>等级：{list[0].numberLevel}</li> : null 
          }{
            list[0].operScore ? <li>操作分数：{list[0].operScore}</li> : null 
          }{
            list[0].sumbitDate ? <li>认证日期：{list[0].sumbitDate}</li> : null 
          }{
            list[0].sumbitUnit ? <li>认证机构：{list[0].sumbitUnit}</li> : null 
          }{
            list[0].textScore ? <li>笔试分数：{list[0].textScore}</li> : null 
          }
        </ul>
      </div>
    )
  }
  toHHmmss = (data)=> {
      if( !data ){
        return false
      }
      let time = new Date(data)
      let year = time.getFullYear()
      let month = time.getMonth() + 1
      let date = time.getDate()
      let hours = time.getHours()
      let minute = time.getMinutes()
      let second = time.getSeconds()

      if (month < 10) { month = '0' + month }
      if (date < 10) { date = '0' + date }
      if (hours < 10) { hours = '0' + hours }
      if (minute < 10) { minute = '0' + minute }
      if (second < 10) { second = '0' + second }
      return year + '-' + month + '-' + date + ' ' + hours + ':' + minute + ':' + second
  };

  render() {

    const { data = {} } = this.props;
    let classname = data.dataFlag === 0 ? "good" : "negative"
    return (
      <div className="resultShow-wrap">
        <div className="top">
          <p className="title">
            {data.itemName}{data.itemId === 11 && <img className="tag"  src='//pic1.58cdn.com.cn/nowater/cxnomark/n_v26a916df50aba4669a2a6f2146db56563.png'/>}
            { data.authTime && <span style={{}}>授权时间：{ this.toHHmmss( data.authTime) }</span>  } 
          </p>
          {
            (() => {
              if (data.dataFlag * 1 === 1) {
                switch (data.itemId) {
                  case 4:
                  case 5:
                    return (<a onClick={() => { this.openPage(data.body.entryId, data.itemId, data.batchId, data.record) }}>查看详情<Icon type="right" /></a>)
                  case 8:
                    if (data.body.list && data.body.list.length === 1) return null;
                    return (<a onClick={() => { this.openPage_one(data.batchId, data.record, "jinrong") }}>查看全部{data.body.list && data.body.list.length}条<Icon type="right" /></a>)
                  case 9:
                    return (<a onClick={() => { this.openPage_one(data.batchId, data.record, "shangye") }}>查看详情<Icon type="right" /></a>)
                  
                  default:
                    return null;
                }
              }else {
                switch (data.itemId) {
                  case 11:
                    if ( !data.body.list || data.body.list.length === 0) return null;
                    if (data.body.list && data.body.list.length === 1) return null;
                    return (<a onClick={() => { this.certificatePage(data.batchId, data.record, "zgzs") }}>{`查看全部${data.body.list.length}条`}<Icon type="right" /></a>)
                  default:
                    return null;
                }
              }
            })()
          }
        </div>
        <p className="subTitle">{data.secDesc}</p>
        <p className={"mark " + classname}>{data.tips}</p>
        {/* 是下面的提示信息 */}
        {data.itemId === 1 && data.dataFlag === 0 && this.resultDetail_identity(data.body)}
        {
          (() => {
            switch (data.itemId * 1) {
              case 4:
              case 5:
                return this.resultDetail(data.body)

              case 7:
                return this.resultDetail_bank()

              case 8:
                return this.resultDetailFinancial()

              case 9:
                return this.resultDetail_shangye()

              case 10:
                if (data.dataFlag === 1) return null;
                return <div className="address">{data.body.address}</div>
              case 11:
                return this.resultDetail_zgzs()
              case 12:
                  return this.resultDetail_jiazhao(data.body)  
              default: return null;
            }
          })()
        }
      </div>
    )
  }

  certificatePage = (batchId, record, dataType) => {
    const { history } = this.props;
    let params = {
      type: "newAjax",
      dataType,
      batchId,
      record,
    }
    const location = {
      pathname: '/resultDetail',
      state: params
    }
    sessionStorage.setItem("params", JSON.stringify(params));
    history.push(location)
  }

  openPage(entryId, itemId,batchId, recordId) {
    let dataType = itemId === 4 ? "cpws" : "shixin";
    const { history } = this.props;
    const location = {
      pathname: '/resultDetail',
      state: { entryId, dataType,batchId, recordId}
    }
    sessionStorage.setItem("params", JSON.stringify(location.state));
    history.push(location)
  }

  openPage_one = (batchId, record, dataType) => {
    const { history } = this.props;
    let params = {
      type: "newAjax",
      dataType,
      batchId,
      record,
    }
    const location = {
      pathname: '/resultDetail',
      state: params
    }
    sessionStorage.setItem("params", JSON.stringify(params));
    history.push(location)
  }

}

export default withRouter(ResultShow);